import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormNotificationOfAppeal } from "../Models/Forms/IFormNotificationOfAppeal";
import { BaseService } from './BaseService';

@Injectable()
export class FormNotificationOfAppealService  extends  BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormNotificationOfAppeal(id: number) {
    return this._http.get(this._baseUrl + "api/FormNotificationOfAppeal/" + id)
      .map((response: IFormNotificationOfAppeal) => response as IFormNotificationOfAppeal)
      .catch(this.errorHandler);
  }

  insertUpdateFormNotificationOfAppeal(formNotificationOfAppealDetails: IFormNotificationOfAppeal) {
    return this._http.post(this._baseUrl + 'api/FormNotificationOfAppeal', formNotificationOfAppealDetails)
      .map((response: IFormNotificationOfAppeal) => response as IFormNotificationOfAppeal)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormNotificationOfAppeal/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteNotificationOfAppeal(id) {
    return this._http.delete(this._baseUrl + "api/FormNotificationOfAppeal" + id)
      .map((response: IFormNotificationOfAppeal) => response as IFormNotificationOfAppeal)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
 
}
